var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-main-content"},[_c('card',{attrs:{"title":"项目财务"}},[_c('echarts',{attrs:{"option":_vm.charsOptions,"width":"100%","height":"600px"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }